import React, { useContext } from 'react';
import * as C from 'src/templates/DashboardTemplate/styles';
import { Avatar, Breadcrumb, Button, Flex, Layout, Typography } from 'antd';
import {
	CloseOutlined,
	LogoutOutlined,
	MenuFoldOutlined,
	MenuUnfoldOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { breadcrumbMap } from 'src/common/mapping/breadcrumbMap';
import SidebarMenu from 'src/components/SidebarMenu';
import { AuthContext } from 'src/AuthProvider';
import ChangeOrganization from 'src/templates/DashboardTemplate/changeOrganization';

type Props = {
	children: React.ReactNode;
	pageTitle?: string;
	contentOnly?: boolean;
	totallyColapseSidebar?: boolean;
};

export default function DashboardTemplate({
	children,
	pageTitle,
	contentOnly,
	totallyColapseSidebar,
}: Props) {
	const { signOut, user, } = useContext(AuthContext);

	const [ isSiderCollapsed, setIsSiderCollapsed, ] =
        React.useState<boolean>(false);

	const [ isSiderBroken, setIsSiderBroken, ] = React.useState<boolean>(false);

	const pathname = useLocation().pathname;

	return (
		<Layout>
			<C.StyledSider
				breakpoint='md'
				onBreakpoint={(broken) => {
					if (broken) setIsSiderCollapsed(true);
					setIsSiderBroken(broken);
				}}
				collapsed={isSiderCollapsed}
				collapsible
				collapsedWidth={isSiderBroken || totallyColapseSidebar ? 0 : 60}
				trigger={null}
				style={{
					position: isSiderBroken ? 'fixed' : 'relative',
					zIndex: 1,
				}}
			>
				{isSiderBroken && (
					<Flex
						style={{ height: 64, }}
						justify='center'
						align='center'
					>
						<C.MobileCloseSiderTrigger
							type='text'
							onClick={() => {
								setIsSiderCollapsed(true);
							}}
							icon={<CloseOutlined style={{ color: 'white', }} />}
						/>
					</Flex>
				)}
				{totallyColapseSidebar && <div style={{ height: 64, }} />}
				{!totallyColapseSidebar && (
					<C.LogoContainer
						imageurl={`${process.env.REACT_APP_PUBLIC_URL}/intraguard_logo.png`}
					/>
				)}
				<SidebarMenu />
			</C.StyledSider>
			<Layout>
				<C.StyledHeader>
					<Button
						onClick={() => setIsSiderCollapsed(!isSiderCollapsed)}
						type='text'
						icon={
							isSiderCollapsed ? (
								<MenuUnfoldOutlined />
							) : (
								<MenuFoldOutlined />
							)
						}
					/>
					{totallyColapseSidebar && (
						<C.LogoContainer
							style={{
								maxHeight: '36px',
								height: '36px',
								minHeight: 0,
								overflow: 'hiddden',
								margin: 0,
								width: 'auto',
								aspectRatio: 1,
							}}
							imageurl={`${process.env.REACT_APP_PUBLIC_URL}/intraguard_logo.png`}
						/>
					)}
					<Flex gap={5}>
						{user?.profile_pic && (
							<Avatar
								src={
									<img
										src={user.profile_pic}
										alt='avatar'
									/>
								}
							></Avatar>
						)}
						<ChangeOrganization />
						<Button
							type='text'
							onClick={() => {
								signOut();
							}}
							icon={<LogoutOutlined title='Sair' />}
						/>
					</Flex>
				</C.StyledHeader>
				<C.MainContent style={contentOnly ? { padding: 0, } : {}}>
					{!contentOnly && (
						<Breadcrumb
							separator='>'
							style={{ marginBottom: 15, }}
							items={
								pathname
									.split('/')
									.filter((item) => item)
									.map((item) => ({ title: item, })).length
									? pathname
										.split('/')
										.map((item) => {
											if (
												item?.match(
													/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
												)?.[0]
											) {
												return 'ID';
											}
											if (!(item in breadcrumbMap))
												return (
													item
														?.slice(0, 1)
														.toUpperCase() +
														item?.slice(1)
												);
											return breadcrumbMap[
												item as keyof typeof breadcrumbMap
											];
										})
										.filter((item) => item)
										.map((item) => ({
											title: item,
											key: crypto.randomUUID(),
										}))
									: [
										{
											title: 'Dashboard',
											key: crypto.randomUUID(),
										},
									]
							}
						/>
					)}
					{pageTitle && (
						<Typography.Title level={3}>
							{pageTitle}
						</Typography.Title>
					)}
					<C.StyledContent>{children}</C.StyledContent>
				</C.MainContent>
			</Layout>
		</Layout>
	);
}
